/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Injectable } from "@angular/core";
var RowActionService = (function () {
    function RowActionService() {
        this.actionableCount = 0;
    }
    RowActionService.prototype.register = function () {
        this.actionableCount++;
    };
    RowActionService.prototype.unregister = function () {
        this.actionableCount--;
    };
    Object.defineProperty(RowActionService.prototype, "hasActionableRow", {
        /**
         * false means no rows with action
         */
        get: function () {
            return this.actionableCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    return RowActionService;
}());
export { RowActionService };
RowActionService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
RowActionService.ctorParameters = function () { return []; };
//# sourceMappingURL=row-action-service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/providers/row-action-service.js
// module id = 38
// module chunks = 4